import { SecureAxios } from './Axios';
import { API_ROOT } from './Constants';
const CacheKey = 'members';
const BASE_PATH = `${API_ROOT}/members`;
const PATHS = {
    DELETE: (memberId) => `${BASE_PATH}/${memberId}`,
    GET: (memberId) => `${BASE_PATH}/${memberId}`,
    LIST: BASE_PATH,
    UPDATE: (memberId) => `${BASE_PATH}/${memberId}`,
};
async function get(memberId) {
    return (await (await SecureAxios()).get(PATHS.GET(memberId))).data;
}
function getKey(memberId) {
    return [CacheKey, 'get', memberId];
}
async function delete_(csrfToken, memberId) {
    return (await (await SecureAxios()).delete(PATHS.DELETE(memberId), { headers: { 'X-CSRF-Token': csrfToken } })).data;
}
async function list(props) {
    const params = new URLSearchParams();
    if (props.limit)
        params.append('limit', props.limit.toString());
    if (props.offset)
        params.append('offset', props.offset.toString());
    if (props.orderBy)
        params.append('orderBy', props.orderBy);
    if (props.order)
        params.append('order', props.order);
    if (props.query)
        params.append('q', props.query);
    return (await (await SecureAxios()).get(`${PATHS.LIST}?${params.toString()}`)).data;
}
function listKey(props) {
    return [CacheKey, 'list', props];
}
async function update(csrfToken, memberId, props) {
    const form = new FormData();
    if (props.role)
        form.append('role', props.role);
    return (await (await SecureAxios()).put(PATHS.UPDATE(memberId), form, { headers: { 'X-CSRF-Token': csrfToken, 'Content-Type': 'multipart/form-data' } })).data;
}
export default { CacheKey, delete_, get, getKey, list, listKey, update };
